"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Star, MapPin, BadgeCheck, ChevronRight } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const reviews = [{
  name: "张伟",
  date: "2周前",
  rating: 5,
  text: "非常棒的租车体验，车辆非常干净，服务也很周到。强烈推荐给来英国旅游的朋友！Ledotravel 的车队管理确实让人放心。",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560445/img/customer_avatar_zhang.png",
  initials: "张"
}, {
  name: "李娜",
  date: "1个月前",
  rating: 5,
  text: "公司长期租赁合作非常顺利，Ledotravel 提供的车队管理让我们省心不少。售后维保也很专业，是值得信赖的商业伙伴。",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560445/img/customer_avatar_li.png",
  initials: "李"
}, {
  name: "王强",
  date: "3个月前",
  rating: 5,
  text: "在这里买了一辆二手车，车况极佳，价格也很公道。销售人员非常耐心解答所有问题，整个购车流程透明高效。",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560445/img/customer_avatar_wang.png",
  initials: "王"
}, {
  name: "刘洋",
  date: "4个月前",
  rating: 4,
  text: "车辆保养速度很快，师傅技术娴熟。休息区的环境也很好，体验满分！唯一的小建议是希望周末能增加一些预约时段。",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560445/img/customer_avatar_liu.png",
  initials: "刘"
}, {
  name: "陈杰",
  date: "半年内",
  rating: 5,
  text: "在线预订系统非常方便，到店直接取车，没有任何隐形消费。下次还会选择他们家，性价比真的很高。",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1560445/img/customer_avatar_chen.png",
  initials: "陈"
}];
export default function GoogleMapReviews() {
  return <section id="googlemapreviews" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-12 gap-8 items-center">
          
          {}
          <div className="col-span-12 lg:col-span-4 flex flex-col items-start space-y-6">
            <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary">
              <MapPin className="size-4" />
              <span>Google 地图评价</span>
            </div>
            
            <div className="space-y-4">
              <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground tracking-tight">
                来自真实客户的反馈
              </h2>
              <p className="text-muted-foreground font-sans text-lg max-w-md">
                了解为什么数百名旅客和企业客户信任 Ledotravel 为他们提供卓越的出行解决方案。
              </p>
            </div>

            <div className="flex items-center gap-4 pt-4">
              <div className="flex items-center">
                <span className="font-default text-4xl font-bold text-foreground mr-2">4.9</span>
                <div className="flex flex-col">
                  <div className="flex text-primary">
                    {[...Array(5)].map((_, i) => <Star key={i} className="size-4 fill-current" />)}
                  </div>
                  <span className="text-xs text-muted-foreground mt-1 font-sans">基于 300+ 条评价</span>
                </div>
              </div>
            </div>

            <Button variant="outline" className="mt-4 group hidden lg:inline-flex">
              查看所有评价
              <ChevronRight className="size-4 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

          {}
          <div className="col-span-12 lg:col-span-8 relative">
            <Carousel opts={{
            align: "start",
            loop: true
          }} className="w-full">
              <CarouselContent className="-ml-4 md:-ml-6">
                {reviews.map((review, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 xl:basis-1/2">
                    <Card className="h-full bg-card shadow-md border-border/50 hover:border-primary/30 transition-colors duration-300 flex flex-col">
                      <CardHeader className="flex flex-row items-center gap-4 pb-4">
                        <SafeHydrate><Avatar className="size-12 border border-border/50 shadow-xs">
                          <AvatarImage src={review.avatar} alt={review.name} />
                          <AvatarFallback className="bg-primary/10 text-primary font-default font-semibold">
                            {review.initials}
                          </AvatarFallback>
                        </Avatar></SafeHydrate>
                        <div className="flex flex-col">
                          <CardTitle className="text-base font-default">
                            {review.name}
                          </CardTitle>
                          <CardDescription className="text-xs font-sans">
                            {review.date}
                          </CardDescription>
                        </div>
                        <div className="ml-auto">
                          <Badge variant="secondary" className="bg-secondary/10 text-secondary-foreground hover:bg-secondary/20 border-none">
                            <BadgeCheck className="size-3 mr-1 text-primary" />
                            已验证
                          </Badge>
                        </div>
                      </CardHeader>
                      <CardContent className="flex-grow flex flex-col justify-between">
                        <div>
                          <div className="flex text-primary mb-4">
                            {[...Array(5)].map((_, index) => <Star key={index} className={`size-4 ${index < review.rating ? "fill-current" : "fill-transparent text-muted-foreground"}`} />)}
                          </div>
                          <p className="text-foreground/80 font-sans text-sm leading-relaxed">
                            "{review.text}"
                          </p>
                        </div>
                      </CardContent>
                    </Card>
                  </CarouselItem>)}
              </CarouselContent>
              <div className="flex justify-end gap-2 mt-8 lg:absolute lg:-bottom-16 lg:right-0">
                <CarouselPrevious className="static translate-y-0 translate-x-0 size-10 bg-background border-border hover:bg-accent hover:text-accent-foreground" />
                <CarouselNext className="static translate-y-0 translate-x-0 size-10 bg-background border-border hover:bg-accent hover:text-accent-foreground" />
              </div>
            </Carousel>
            
            <Button variant="outline" className="w-full mt-8 group lg:hidden">
              查看所有评价
              <ChevronRight className="size-4 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>

        </div>
      </div>
    </section>;
}